import React from "react";
import MainTabs from "./MainTabs/MainTabs";
import LoaderComponent from "../commonComponents/LoadableComp/LoadableComp";
import { useSelector } from "react-redux";

const Intervistat = () => {
  return (
    <LoaderComponent>
      <div className="globalPageWrapper">
        <MainTabs />
      </div>
    </LoaderComponent>
  );
};

export default Intervistat;
